import $ from 'jquery'
import {CURRENCY, getSelector, selectors} from "../global/index"
import Layout from './Layout'

const Delivery = {

    refreshDeliveryOptions: (loading, options, selectedRateId, message) => {
        let html = ''
        if(loading) {
            html = `<div style="padding:48px 32px; text-align: center;">
                            ${Layout.renderLoader()}
                        </div>`

        }
        else if(options) {

           let shipping = Object.keys(options).map(ii => options[ii])
            html = shipping.map((item) => {
				// `Athan` is not including tax in product price, which makes delivery price either.
	            // As asked, include tax which displaying on the site.
	            var _price = Number(item.price * 1.1).toFixed(2);

                let checked = (String(item.deliveryId) === String(selectedRateId)) ? 'checked' : ''

	            // add extra text for FedEx
				let extraExp = '';
				if (item.name.substring(0, 5).toLowerCase() == 'fedex') {
					extraExp = '<p style="font-size:14px">Athan Wholesale Jewellers will reach out to arrange international shipping</p>';
				}
	            return `<div class="radio__copy">
                <input class="radio" value="${item.deliveryId}" data-deliveryid="${item.deliveryId}" data-price="${item.price}" type="radio" id="option--${item.deliveryId}" name="shippingradio" ${checked} />
                <label  class="radio__label" for="option--${item.deliveryId}"> 
                    <i class="fa"></i> 
                    ${CURRENCY}${_price} - ${item.name}${extraExp}                    
                </label>
            </div>`
            }).join(' ')

        }
        else {
            let msg = message ? message : 'Please complete Delivery Contact Information.'
            html = `<p style="padding: 32px;">
                            ${msg} 
                        </p>`

        }
        getSelector(selectors.deliveryOptions).html(html)
    },

    refreshRateIdInput: (rateId) => {
        let value = rateId ? rateId : ''
        let input = getSelector(selectors.rateId)
        input.val(value)

    }

}

export default Delivery